/* -------------------------- Design imports start -------------------------- */
import { Chip, Grid } from '@mui/material'
import { t } from 'i18next'

import Button from '../../components/Button'
import InfoField from '../../components/inputs/InfoField'
import InfoPanel from '../../components/layout/InfoPanel'
/* --------------------------- Design imports end --------------------------- */

/* ------------------------ Functional imports start ------------------------ */

import LogTool from '../../logger/logTools'
import { type GuestRequest } from '../UnauthRequest/utils/types'
/* ------------------------- Functional imports end ------------------------- */

type Props = {
  open: boolean
  setOpen: (open: boolean) => void
  setOpenFilesDrawer: (open: boolean) => void
  infoData: GuestRequest | undefined
  title?: string
  disabled?: boolean
}

type ContentProps = {
  setOpenFilesDrawer: (open: boolean) => void
  infoData: GuestRequest | undefined
}

export function GuestRequestInfoPanelContent(props: ContentProps) {
  /* -------------------------- Non state data start -------------------------- */
  const { setOpenFilesDrawer, infoData } = props
  const log = new LogTool({ context: 'GuestRequestInfoPanel', enable: true, logLevel: 'warn' })
  /* --------------------------- Non state data end --------------------------- */
  /* ---------------------------- Flag states start --------------------------- */

  /* ----------------------------- Flag states end ---------------------------- */

  /* ---------------------------- Data states start --------------------------- */

  /* ----------------------------- Data states end ---------------------------- */

  /* ------------------------------ Effects start ----------------------------- */
  /* ------------------------------- Effects end ------------------------------ */

  /* ------------------------- Utility functions start ------------------------ */

  /* -------------------------- Utility functions end ------------------------- */

  /* ------------------------ Callback functions start ------------------------ */
  // some callback functions...
  /* ------------------------- Callback functions end ------------------------- */

  /* ------------------------- Render constants start ------------------------- */
  /* -------------------------- Render constants end -------------------------- */

  /* ------------------------ Pre render actions start ------------------------ */
  // Effects that should happen on certain re-renders, that are not allowed in
  // useEffect because of setting states
  // e.g. setArticleOptions on the NewItemPage should be called every time the modal
  // is opened
  /* ------------------------- Pre render actions end ------------------------- */

  /* -------------------------------------------------------------------------- */
  /*                              Render Component                              */
  /* -------------------------------------------------------------------------- */

  log.debug('InfoData -> ', infoData)
  return (
    <>
      <Grid container spacing={2} style={{ padding: '20px' }}>
        <Grid item xs={12}>
          <InfoField label={t('common:content.label.name')} fullWidth value={infoData?.name} />
        </Grid>
        <Grid item xs={12}>
          <InfoField label={t('request:content.label.email')} fullWidth value={infoData?.email} />
        </Grid>
        <Grid item xs={12}>
          <InfoField
            label={t('request:content.label.company')}
            fullWidth
            value={infoData?.company}
          />
        </Grid>
        <Grid item xs={12}>
          <InfoField label={t('request:content.label.phone')} fullWidth value={infoData?.phone} />
        </Grid>
        <Grid item xs={12}>
          <InfoField
            label={t('request:content.label.quantity')}
            fullWidth
            value={infoData?.quantity}
          />
        </Grid>
        <Grid item xs={12}>
          <InfoField
            label={t('common:content.label.material')}
            fullWidth
            value={infoData?.material}
          />
        </Grid>
        <Grid item xs={12}>
          <InfoField
            label={t('request:content.label.description')}
            fullWidth
            value={infoData?.message}
          />
        </Grid>
        {/* TODO: generate types -- createdAt is missing for guestRequest! */}
        {/* <Grid item xs={12}>
            <InfoField
              label={t('common:content.label.createdAt')}
              fullWidth
              value={infoData?.createdAt}
            />
          </Grid> */}
        <Grid item xs={12}>
          <InfoField label={t('common:content.label.status')} fullWidth value={infoData?.status} />
        </Grid>
        {infoData?.remarks !== undefined && (
          <Grid item xs={12}>
            <InfoField
              label={t('common:content.label.remarks')}
              fullWidth
              value={infoData?.remarks}
            />
          </Grid>
        )}
        {Array.isArray(infoData?.editors) && infoData?.editors?.length > 0 && (
          <Grid item xs={12}>
            <InfoField
              label={t('common:content.label.editors')}
              fullWidth
              value={infoData?.editors?.map(editor => {
                if (typeof editor === 'string') {
                  return (
                    <Chip key={editor} label={editor} variant="outlined" style={{ marginRight: '5px' }} />
                  )
                }
                const fullName = [editor.firstName, editor.lastName].filter(Boolean).join(' ')
                return (
                  <Chip
                    key={editor.self}
                    label={fullName || editor.self}
                    variant="outlined"
                    style={{ marginRight: '5px' }}
                  />
                )
              })}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <Button
            id="showFilesButton"
            fullWidth
            variant="contained"
            onClick={() => {
              setOpenFilesDrawer(true)
            }}
          >
            {t('common:interaction.button.showFiles')}
          </Button>
        </Grid>
      </Grid>
    </>
  )
}

export default function GuestRequestInfoPanel(props: Props) {
  /* -------------------------- Non state data start -------------------------- */
  const { open, setOpen, setOpenFilesDrawer, infoData, title, disabled = true } = props
  /* --------------------------- Non state data end --------------------------- */

  /* -------------------------------------------------------------------------- */
  /*                              Render Component                              */
  /* -------------------------------------------------------------------------- */

  return (
    <InfoPanel
      open={open}
      setOpen={setOpen}
      label={title || t('request:content.label.guestRequestInformation')}
      allowEdit={false}
      disabled={disabled}
    >
      <GuestRequestInfoPanelContent
        setOpenFilesDrawer={setOpenFilesDrawer}
        infoData={infoData}
      />
    </InfoPanel>
  )
}
